import AddIcon from '@mui/icons-material/Add'

import { useAppDispatch } from 'app/hooks'

import { setSelectedScenarioSync } from 'features/RiskManagement/Assessments/Scenarios/whatIfScenarioSlice'

import { CreateScenarioButtonProps } from './types'

const CreateScenarioButton = ({ onClick }: CreateScenarioButtonProps) => {
  const dispatch = useAppDispatch()

  const handleCreateNewScenario = () => {
    onClick()

    /*
     * When setSelectedScenario is called the component state becomes null but the store state doesn't
     *  change due to the state being null.

     * dispatch(setSelectedScenarioSync({ id: 0, name: '', rules: [] })) is called to change the
     *  store state to the initial state in the store. null can't be used because it is not type IQRAScenario
     */

    dispatch(setSelectedScenarioSync({ id: 0, name: '', rules: [] }))
  }

  return (
    <button
      type='button'
      className='align-middle font-medium text-lighthouseBlue disabled:opacity-50'
      onClick={handleCreateNewScenario}
    >
      <AddIcon className='mb-1 mr-1' />
      <span>Create New Scenario</span>
    </button>
  )
}

export default CreateScenarioButton
